// src/components/Lightbox.jsx (GÜNCELLE)
import React, { useEffect } from "react";

export default function Lightbox({ open, onClose, item }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === "Escape") onClose?.(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open || !item) return null;

  return (
    <div className="lb-backdrop" role="dialog" aria-modal="true" onClick={onClose}>
      <div className="lb-content" onClick={(e) => e.stopPropagation()}>
        <button className="lb-close" aria-label="Kapat" onClick={onClose}>×</button>

        {item.type === "video" ? (
          <video
            controls
            playsInline
            preload="metadata"
            poster={item.poster}
            style={{ maxWidth: "min(1200px, 95vw)", maxHeight: "80vh", width: "100%" }}
          >
            <source src={item.src} type="video/mp4" />
            Tarayıcınız video etiketini desteklemiyor.
          </video>
        ) : (
          <img
            src={item.full || item.thumb}
            alt={item.alt || item.title}
            decoding="async"
            style={{ maxWidth: "min(1200px, 95vw)", maxHeight: "80vh", width: "100%", objectFit: "contain" }}
          />
        )}

        <div className="lb-caption">
          <strong>{item.title}</strong>
          {item.date ? <span style={{ marginLeft: 8, opacity: .8 }}>• {item.date}</span> : null}
        </div>
      </div>
    </div>
  );
}